// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-upload[data-v-4f826b76]{margin:0}.netdiskModal-iframe[data-v-4f826b76]{width:100%;height:500px;border:1px solid #eee}", ""]);
// Exports
module.exports = exports;
